import { Box, IconButton, InputAdornment, Modal, TextField, Typography, FormControlLabel, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { GrClose } from 'react-icons/gr';
import { MdContentCopy } from 'react-icons/md';
import CustomInputField from '../../Common_Components/CustomInputField'
import ResetButton from '../../Common_Components/ResetButton';
import axiosInstance from '../../axios/axios';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import { Toast } from '../../Common_Components/Toast';
import CustomTextArea from '../../Common_Components/CustomTextArea';

const AddLicenseModal = ({ open, handleClose }) => {
    const [licenseNumber, setLicenseNumber] = useState(''); // Mock license number
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(licenseNumber);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    };
    const [dis, setDis] = useState(false)
    const [clientLists, setClientLists] = useState([])
    const [selectedClient, setSelectedClient] = useState(null)
    const [productLists, setProductLists] = useState([])
    const [products, setProducts] = useState([])
    const [selectedProduct, setSelectedproduct] = useState(null)
    const [version, setVersion] = useState('')
    const [licenseTypeLists, setLicenseTypeList] = useState([])
    const [licenseType, setLicenseType] = useState(null)
    const [licenseduration, setLicenseDuration] = useState('')
    const [uniqueNumber, setUniqueNumber] = useState('')
    const [remarks, setRemarks] = useState('')
    const [licensecount, setLicenseCount] = useState('')
    const [graceperiod, setGraceperiod] = useState(0)
    useEffect(() => {
        const getClientList = async () => {
            const response = await axiosInstance.post('/clients/clientList')
            const { success, clients } = response.data
            if (success === true) {
                const clientlist = clients && clients.filter((value) => {
                    return Number(value.CD_Status) === 1
                })
                const vals = clientlist && clientlist.map((val) => {
                    return { id: val.CD_Id, label: val.CD_Name }
                })
                setClientLists(vals)
            } else {
                setClientLists([])
            }
        }
        const getProductList = async () => {
            const response = await axiosInstance.post('/product/List')
            const { success, products } = response.data
            if (success === true) {
                const productlist = products && products.filter((value) => {
                    return Number(value.PD_StatusID) === 1
                })
                setProducts(productlist)
                const vals = productlist && productlist.map((val) => {
                    return { id: val.PD_Id, label: val.PD_Name }
                })
                setProductLists(vals)
            } else {
                setProductLists([])
            }
        }
        const fetchLicenseTypes = async () => {
            try {
                const response = await axiosInstance.get('/common/licenseTypes');
                const { success, LicenseTypeList } = response.data
                if (success === true) {
                    const vals = LicenseTypeList && LicenseTypeList.map((val) => {
                        return { id: val.LT_Id, label: val.LT_Name }
                    })
                    setLicenseTypeList(vals)
                } else {
                    setLicenseTypeList([])
                }
            } catch (error) {
                console.error('Error fetching countries:', error);
                // Toast.error('Failed to fetch countries.');
            }
        };
        if (open) {
            getClientList()
            getProductList()
            fetchLicenseTypes()
        }

    }, [open])

    useEffect(() => {
        if (selectedProduct) {
            const res = products && products.filter((val) => {
                return Number(val.PD_Id) === Number(selectedProduct.id)
            })
            res.length > 0 ? setVersion(res[0].PD_Version) : setVersion('')
        }
    }, [selectedProduct])

    const handleInputChangelicenseDuration = (e) => {
        setLicenseDuration(e.target.value)
    }
    const handleInputChangegraceperiod = (e) => {
        setGraceperiod(e.target.value)
    }
    const handleInputChangelicenseCount = (e) => {
        setLicenseCount(e.target.value)
    }

    const generateLicenseKey = async (e) => {
        setDis(true)
        e.preventDefault();
        const request = {
            LD_ClientID: selectedClient?.id,
            LD_ProductID: selectedProduct?.id,
            LD_Version: version,
            LD_LicenseTypeID: licenseType?.id,
            LD_UserLicenseCount: licensecount,
            LD_SerialNumber: uniqueNumber,
            LD_LicenseDuration: Number(licenseType?.id) === 4 || Number(licenseType?.id) === 5 ? licenseduration : 365,
            LD_CreatedBy: 0,
            LD_Remarks: remarks,
            LD_graceperiod: graceperiod
        }
        const response = await axiosInstance.post('/licenses/create', request)
        const { success, message, license } = response.data
        if (success === true) {
            setLicenseNumber(license?.key)
            Toast.success(message)
            setDis(true)
        } else {
            setDis(false)
            Toast.warning(message)
        }
    }
    const handleCloseButton = () => {
        setSelectedClient(null)
        setSelectedproduct(null)
        setVersion('')
        setLicenseType(null)
        setLicenseDuration('')
        setUniqueNumber('')
        setRemarks('')
        setLicenseCount('')
        setLicenseNumber('')
        setDis(false)
        handleClose()
    }
    return (
        <Modal open={open} onClose={handleCloseButton}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 800,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={2} sx={{ borderBottom: '1px solid #E4E4E4' }}>
                    <Typography sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: '700',
                        fontSize: '32px',
                        color: '#545454',
                    }}>
                        Add License
                    </Typography>
                    <IconButton onClick={handleCloseButton}>
                        <GrClose />
                    </IconButton>
                </Box>

                {/* First Row: Product, Version, Client */}
                <Box display="flex" gap={2} mb={2}>
                    <Box width="50%">
                        <CustomSelectBox
                            label="Product"
                            options={productLists}
                            Value={selectedProduct}
                            setValue={setSelectedproduct}
                            fullWidth
                        />
                    </Box>
                    <Box width="50%">
                        <CustomInputField
                            label="Version"
                            value={version}
                            disabled={true}
                        />
                    </Box>
                    <Box width="50%">
                        <CustomSelectBox
                            label="Client"
                            options={clientLists}
                            Value={selectedClient}
                            setValue={setSelectedClient}
                            fullWidth
                        />
                    </Box>
                </Box>


                {/* Second Row: Checkboxes */}
                {/* <Box display="flex" justifyContent="space-between" mb={2}>
                    <FormControlLabel control={<Checkbox />} label="Trial" />
                    <FormControlLabel control={<Checkbox />} label="Purchase" />
                    <FormControlLabel control={<Checkbox />} label="Renewal" />
                    <FormControlLabel control={<Checkbox />} label="Additional License" />
                </Box> */}

                {/* Third Row: Subscription Period, No. of License */}
                <Box display="flex" gap={2} mb={2}>
                    <Box width="50%">
                        <CustomSelectBox
                            label="License Type"
                            options={licenseTypeLists}
                            Value={licenseType}
                            setValue={setLicenseType}
                            fullWidth
                        />
                    </Box>
                    <Box width="50%">
                        <CustomInputField
                            label="License Duration(In Days)"
                            type="Number"
                            name="licenseduration"
                            value={licenseduration}
                            disabled={Number(licenseType?.id) === 4 || Number(licenseType?.id) === 5 ? false : true}
                            onChange={handleInputChangelicenseDuration}
                            fullWidth
                        />
                    </Box>
                    <Box width="50%">
                        <CustomInputField
                            label="User Count"
                            type="Number"
                            name="licensecount"
                            value={licensecount}
                            disabled={Number(licenseType?.id) === 5 ? true : false}
                            onChange={handleInputChangelicenseCount}
                            fullWidth
                        />
                    </Box>
                    {
                        Number(licenseType?.id) === 4 ? <Box width="50%">
                            <CustomInputField
                                label="Grace Period"
                                type="Number"
                                name="graceperiod"
                                value={graceperiod}
                                onChange={handleInputChangegraceperiod}
                                fullWidth
                            />
                        </Box> : null
                    }
                </Box>
                {/* <Box display="flex" gap={2} mb={2} >
                    <Box width="100%">
                        <CustomInputField
                            label="Unique Serial Number"
                            name="uniqueNumber"
                            value={uniqueNumber}
                            onChange={handleInputChangeUniqueNumber}
                            fullWidth
                        />
                    </Box>
                </Box> */}
                <Box display="flex" gap={2} mb={2} >
                    <Box width="100%">
                        <CustomTextArea
                            label="Remarks"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            rows={3}
                            fullWidth
                        />
                    </Box>
                </Box>
                {/* Fourth Row: Generate License Button */}
                <Box display="flex" justifyContent="left" mb={2} >
                    <Button sx={{
                        width: '296px',
                        height: '49px',
                        borderRadius: '5px',
                        fontFamily: 'Times New Roman',
                        fontWeight: '400',
                        fontSize: '18px',
                        color: '#FFFFFF',
                        backgroundColor: '#5C3685',
                        textTransform: 'capitalize'

                    }}
                        disabled={dis}
                        onClick={generateLicenseKey}

                    >Generate License</Button>
                </Box>

                {/* Fifth Row: Unique License Number with Copy Icon */}
                <Box alignItems="center" gap={2} sx={{ flexDirection: 'row' }}>
                    <Typography sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: '400',
                        fontSize: '18px',
                        lineHeight: '20.7px',
                        color: '#3D3D3D',
                        paddingBottom: '10px'
                    }}>{"License key"}</Typography>
                    <TextField
                        value={licenseNumber}
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleCopy}>
                                        <MdContentCopy />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {copied && <Typography color="green">Copied!</Typography>}
                </Box>
                <Box display="flex" justifyContent="right" mt={2} >
                    <ResetButton label={"Close"} onClick={handleCloseButton} />
                </Box>
            </Box>
        </Modal >
    );
};

export default AddLicenseModal;
